if (!customElements.get('purchase-popup')) {
  customElements.define(
    'purchase-popup',
    class PurchasePopup extends HTMLElement {
      connectedCallback() {
        this.items = this.shuffle(Array.from(this.querySelectorAll('.purchase-popup__item')));
        if (this.items.length === 0) return;

        this.delay = Number(this.dataset.delay) || 3000;
        this.duration = Number(this.dataset.duration) || 6000;
        this.gap = Number(this.dataset.gap) || 10000;
        this.index = 0;

        this.items.forEach((item) => {
          item.querySelector('.purchase-popup__close')?.addEventListener('click', () => this.hide(item));
        });

        this.timeout = setTimeout(() => this.showNext(), this.delay);
      }

      disconnectedCallback() {
        clearTimeout(this.timeout);
      }

      shuffle(array) {
        for (let i = array.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [array[i], array[j]] = [array[j], array[i]];
        }
        return array;
      }

      showNext() {
        if (this.index >= this.items.length) {
          this.items = this.shuffle(this.items);
          this.index = 0;
        }

        const item = this.items[this.index];
        item.classList.add('is-visible');

        this.timeout = setTimeout(() => this.hide(item), this.duration);
      }

      hide(item) {
        item.classList.remove('is-visible');
        this.index += 1;

        this.timeout = setTimeout(() => this.showNext(), this.gap);
      }
    }
  );
}
